<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">ログイン後ポップアップ通知一覧</h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      <input
        id="chkkikan"
        type="checkbox"
        class="form-check-input"
        v-model="isUnlimitDate"
      />
      <label for="chkkikan" class="form-check-label" style="margin-right: 1rem"
        >表示期間外も表示する</label
      >
      <button
        type="button"
        name="mBtnDisp"
        class="btn btn-primary btn-sm"
        @click="onClickDisp"
      >
        表示
      </button>
      <!-- ログイン後ポップアップ通知一覧 -->
      <div class="">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="col_selection">削除</th>
              <th class="col_btnUpdate">編集</th>
              <th
                :class="[
                  'col_hyojiKikan',
                  'sortable',
                  isDirectionDesc('keisaiKikanStart') ? 'desc' : 'asc',
                ]"
                @click="onSortItem('keisaiKikanStart')"
              >
                表示期間
              </th>
              <th class="col_title">タイトル</th>
              <th class="col_hyojiTaisho">表示対象</th>
              <th class="col_checkPattern">チェックパターン</th>
              <th class="col_checkHyoujiTaisho">チェック表示対象</th>
              <th class="col_preview">プレビュー</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in popupDataList" :key="item.contentsId">
              <td data-name="mSelection" style="text-align: center">
                <input
                  id="mSelection"
                  v-model="item.selection"
                  type="checkbox"
                  class="form-check-input"
                />
              </td>
              <td data-name="mBtnUpdate" style="text-align: center">
                <button
                  type="button"
                  name="mBtnUpdate"
                  class="btn btn-primary btn-sm"
                  @click="showUpdate(item.contentsId)"
                >
                  編集
                </button>
              </td>
              <td data-name="mDisapDate" style="text-align: center">
                {{ item.dispDate }}
              </td>
              <td
                data-name="mTitle"
                style="text-align: left; padding-left: 8px"
              >
                {{ item.title }}
              </td>
              <td
                data-name="mHyoujiTaisho"
                style="text-align: left; padding-left: 8px"
              >
                {{ item.hyojiTaisho }}
              </td>
              <td
                data-name="mCheckHyoujiTaisho"
                style="text-align: left; padding-left: 8px"
              >
                {{ item.checkPatarn }}
              </td>
              <td
                data-name="mCheckPattern"
                style="text-align: left; padding-left: 8px"
              >
                {{ item.checkDispTarget }}
              </td>
              <td data-name="mBtnUpdate" style="text-align: center">
                <button
                  type="button"
                  name="mBtnUpdate"
                  class="btn btn-primary btn-sm"
                  @click="onPreviewLoginPopup(item.contentsId)"
                >
                  プレビュー
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="form-inline flex-container">
          <div class="form-group">
            <button
              type="button"
              name="btnDelete"
              class="btn btn-footer btn-primary"
              @click="onDelete"
            >
              削除
            </button>
          </div>

          <div class="form-group">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="onBack"
            >
              戻る
            </button>

            <button
              type="button"
              name="btnAdd"
              class="btn btn-footer btn-primary"
              @click="showAdd"
            >
              新規登録
            </button>
          </div>
        </div>
      </div>
    </section>
    <!-- ログイン後ポップアップ通知 -->
    <LoginPopupModalComponent
      v-if="isOpenLoginPopupModal"
      :isOpen="isOpenLoginPopupModal"
      :categoryId="previewCategoryId"
      :contentsId="previewContentsId"
      :is-preview="true"
      @closed="handleLoginPopupModalClosed"
    />
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import { useRouter } from "vue-router";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import apiAuthClient from "@/util/apiClientAuth";
import { AppConstants } from "@/constants/AppConstants";
import {
  formatMessage,
  commonHandleAxiosError,
  isTokenAlive,
  getTargetDate,
} from "@/Common";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import LoginPopupModalComponent from "../layout/LoginPopupModalComponent.vue";

interface popupDataList {
  selection: boolean;
  categoryId: string;
  contentsId: string;
  keisaiKikanStart: string;
  keisaiKikanEnd: string;
  hyojiTaisho: number;
  dispDate: string;
  title: string;
  checkPatarn: string;
  checkDispTarget: string;
}

interface PopupData {
  categoryId: string;
  contentsId: string;
}

interface popupSortItem {
  key: string;
  direction: string;
}

class PopupListConstants {
  // ソート種別
  static readonly SORT_TYPE_ASC = "ASC"; // 昇順
  static readonly SORT_TYPE_DESC = "DESC"; // 降順
}

export default defineComponent({
  name: "LoginPopupListComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    LoginPopupModalComponent,
  },
  setup() {
    const router = useRouter();
    const { logoutUser } = useUserStore();
    const { getCategoryIdByName } = useUserParmitionStore();
    const processingStore = useProcessingStore();
    const errorMessage = ref("");
    const agCode = ref("");
    const userId = ref("");
    const isUnlimitDate = ref(false); // 表示期間外も表示する
    const popupDataList = ref<popupDataList[]>([]);
    const popupSortItemList = ref<popupSortItem[]>([]);
    const isInitError = ref(false); // 初期表示時のエラーフラグ
    const contentsCategoryId = ref<string | null>(null); // コンテンツカテゴリID
    const isOpenLoginPopupModal = ref(false);
    let previewCategoryId = ref("");
    let previewContentsId = ref("");

    onMounted(async () => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
      }

      // コンテンツカテゴリID取得
      contentsCategoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_LOGIN_POPUP
      );

      // 処理中フラグON
      processingStore.isProcessing = true;
      // 初期処理時はTrue
      isInitError.value = true;

      try {
        // ログイン後ポップアップ通知一覧データ取得
        if (!(await getPopupList())) {
          return;
        }
        // 初期処理が正常に終了したら解除
        isInitError.value = false;
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * ログイン後ポップアップ通知一覧データ取得
     */
    const getPopupList = async (): Promise<boolean> => {
      try {
        const response = await apiAuthClient.post(
          "/api/LoginPopupReg/GetPopupList",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            categoryId: contentsCategoryId.value,
            targetDate: getTargetDate(""),
            isUnlimitDate: isUnlimitDate.value,
          }
        );

        // レスポンスを保持
        popupDataList.value = response.data.popupList;
        console.log(popupDataList.value);

        // ソート状態を保持
        popupSortItemList.value = getSortItemListDef();
        return true;
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        return false;
      }
    };

    const onClickDisp = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      try {
        // ログイン後ポップアップ通知一覧データ取得
        await getPopupList();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 新規登録ボタン押下
     */
    const showAdd = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // sessionStorageにログイン後ポップアップ通知登録のパラメータ保存
      sessionStorage.setItem(
        AppConstants.LOGIN_POPUP_REG_SESSION_NAME,
        JSON.stringify({
          categoryId: contentsCategoryId.value,
          processingMode: AppConstants.LOGIN_POPUP_EDIT_MODE_NEW,
        })
      );

      // ログイン後ポップアップ通知登録画面へ遷移
      router.push({
        path: "/login-popup-reg",
      });
    };

    /**
     * 編集ボタン押下
     * @param contentsId コンテンツID
     */
    const showUpdate = (contentsId: string) => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 対象行取得
      const target = getPopupData(contentsId);
      if (!target) {
        return;
      }

      // sessionStorageにログイン後ポップアップ通知登録のパラメータ保存
      sessionStorage.setItem(
        AppConstants.LOGIN_POPUP_REG_SESSION_NAME,
        JSON.stringify({
          categoryId: target.categoryId,
          contentsId: target.contentsId,
          processingMode: AppConstants.LOGIN_POPUP_EDIT_MODE_UPDATE,
        })
      );

      // ログイン後ポップアップ通知登録画面へ遷移
      router.push({
        path: "/login-popup-reg",
      });
    };

    /**
     * コンテンツIDに該当するログイン後ポップアップ通知情報を返却します。
     * @param contentsId コンテンツID
     */
    const getPopupData = (contentsId: string): popupDataList | null => {
      const popupData = popupDataList.value.find(
        (popupData) => popupData?.contentsId == contentsId
      );
      return popupData ? popupData : null;
    };

    /**
     * 削除ボタン押下
     */
    const onDelete = async () => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // 削除対象絞り込み
        const targetList: PopupData[] = popupDataList.value
          .filter((popup) => popup.selection)
          .map((popup) => ({
            categoryId: popup.categoryId,
            contentsId: popup.contentsId,
          }));

        // 選択件数チェック
        if (targetList.length < 1) {
          errorMessage.value = formatMessage(messages.ERR_0003, "明細");
          return;
        }

        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "ログイン後ポップアップ通知", "削除")
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // ログイン後ポップアップ通知削除
        try {
          // トークン有効性チェック
          if ((await isTokenAlive()) == false) {
            // トークンが無効な場合はログイン画面へ
            logoutUser();
            alert(messages.ERR_USER001);
            router.push("/login");
            return;
          }

          // API呼出し
          await apiAuthClient.post("/api/LoginPopupReg/DeletePopupData", {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            popupIdList: targetList,
          });

          // 完了メッセージ表示
          alert(
            formatMessage(
              messages.INF_0001,
              "ログイン後ポップアップ通知",
              "削除"
            )
          );

          // ログイン後ポップアップ通知一覧データ取得
          await getPopupList();
        } catch (error: unknown) {
          // エラー処理
          handleAxiosError(error);
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 管理者トップへ遷移
      router.push("/kanrisya-top");
    };

    /**
     * 検索結果のソート処理を行います。
     * @param key ソート項目
     */
    const onSortItem = (key: string) => {
      popupSortItemList.value.forEach((sortItem) => {
        if (sortItem.key == key) {
          if (sortItem.direction == PopupListConstants.SORT_TYPE_ASC) {
            // 降順
            if (key === "keisaiKikanStart") {
              popupDataList.value.sort((a, b) => {
                const startComparison = b.keisaiKikanStart.localeCompare(
                  a.keisaiKikanStart
                );
                if (startComparison !== 0) {
                  return startComparison;
                }
                // 掲載期間のFROMが同じ場合はTOでソート
                return b.keisaiKikanEnd.localeCompare(a.keisaiKikanEnd);
              });
            } else if (key === "keisaiKikanEnd") {
              popupDataList.value.sort((a, b) =>
                b.keisaiKikanEnd.localeCompare(a.keisaiKikanEnd)
              );
            }
          } else {
            // 昇順
            if (key === "keisaiKikanStart") {
              popupDataList.value.sort((a, b) => {
                const startComparison = a.keisaiKikanStart.localeCompare(
                  b.keisaiKikanStart
                );
                if (startComparison !== 0) {
                  return startComparison;
                }
                // 掲載期間のFROMが同じ場合はTOでソート
                return a.keisaiKikanEnd.localeCompare(b.keisaiKikanEnd);
              });
            } else if (key === "keisaiKikanEnd") {
              popupDataList.value.sort((a, b) =>
                a.keisaiKikanEnd.localeCompare(b.keisaiKikanEnd)
              );
            }
          }
        }

        if (sortItem.direction == PopupListConstants.SORT_TYPE_ASC) {
          sortItem.direction = PopupListConstants.SORT_TYPE_DESC;
        } else {
          sortItem.direction = PopupListConstants.SORT_TYPE_ASC;
        }
      });
    };

    /**
     * ソート項目の初期値を返却します。
     */
    const getSortItemListDef = () => {
      return [
        {
          key: "keisaiKikanStart",
          direction: PopupListConstants.SORT_TYPE_DESC,
        },
      ];
    };

    /**
     * ソート順が降順か判定します。
     * @param key ソート項目
     */
    const isDirectionDesc = (key: string): boolean => {
      let result = false;
      popupSortItemList.value.forEach((sortItem) => {
        if (sortItem.key == key) {
          if (sortItem.direction == PopupListConstants.SORT_TYPE_DESC) {
            result = true;
          }
        }
      });
      return result;
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
    };

    /**
     * ログイン後ポップアップ通知プレビュー表示
     */
    const onPreviewLoginPopup = (contentsId: string) => {
      // 対象行取得
      const target = getPopupData(contentsId);
      if (!target) {
        return;
      }

      previewCategoryId.value = target.categoryId;
      previewContentsId.value = target.contentsId;

      isOpenLoginPopupModal.value = true;
      document.body.classList.add("modal-open");
    };

    /**
     * ログイン後ポップアップ通知プレビュー終了処理
     */
    const handleLoginPopupModalClosed = () => {
      isOpenLoginPopupModal.value = false;
      document.body.classList.remove("modal-open");
    };

    return {
      errorMessage,
      isInitError,
      isUnlimitDate,
      popupDataList,
      showAdd,
      showUpdate,
      onDelete,
      onBack,
      onClickDisp,
      onSortItem,
      isDirectionDesc,
      isOpenLoginPopupModal,
      previewCategoryId,
      previewContentsId,
      onPreviewLoginPopup,
      handleLoginPopupModalClosed,
    };
  },
});
</script>
<style scoped>
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
}
.col_selection {
  width: 4%;
}
.col_btnUpdate {
  width: 5%;
}
.col_hyojiKikan {
  width: 18%;
}
.col_title {
  width: 28%;
}
.col_hyojiTaisho {
  width: 10%;
}
.col_checkPattern {
  width: 14%;
}
.col_checkHyoujiTaisho {
  width: 12%;
}
.col_preview {
  width: 8%;
}
.changed {
  background-color: #bed0f3;
}
.unchanged {
  background-color: #fffdbf;
}
.sortable {
  cursor: pointer;
  position: relative;
  padding-right: 20px;
}
.sortable::after {
  content: "";
  position: absolute;
  right: 5px;
}
.sortable.asc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: 0.1em 0 0 0.6em;
  transform: rotate(-135deg);
  vertical-align: middle;
  width: 8px;
}
.sortable.desc::after {
  border: solid #000;
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  height: 8px;
  position: relative;
  transition: 0.2s;
  margin: -0.5em 0 0 0.6em;
  transform: rotate(45deg);
  vertical-align: middle;
  width: 8px;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
  justify-content: space-between;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
.table > :not(caption) > * > * {
  padding: 0rem 0.2rem;
}
thead {
  text-align: center;
  vertical-align: middle;
}
.thead-light {
  background-color: lightgray;
}
tbody {
  text-align: center;
  vertical-align: middle;
}
.form-check-input#chkkikan {
  margin-bottom: -0.1rem;
  margin-right: 0.4rem;
  margin-left: 0.2rem;
  vertical-align: inherit;
}
</style>
